( () => {

    const $subMenuWraps = document.querySelectorAll('.site-menu-bar .menu-item-has-children');

    if ( !$subMenuWraps ) return;

    const enableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        const $activeSubMenuWraps = document.querySelectorAll('.site-menu-bar .menu-item-has-children.active');

        if ( $activeSubMenuWraps ) $activeSubMenuWraps.forEach( $activeSubMenuWrap => {
            if ( $activeSubMenuWrap.querySelector(`#${$subMenuWrap.id}`) ) return;

            disableSubMenu($activeSubMenuWrap, $subMenuToggle);
        } );

        $subMenuWrap.classList.add('active');

        $subMenuToggle.setAttribute('aria-expanded', 'true');
        $subMenuToggle.setAttribute('aria-expanded', 'true');
    };

    const disableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        $subMenuWrap.classList.remove('active');

        $subMenuToggle.setAttribute('aria-expanded', 'false');
        $subMenuToggle.setAttribute('aria-expanded', 'false');
    };

    $subMenuWraps.forEach( $subMenuWrap => {
        $subMenuToggle = $subMenuWrap.querySelector('a');

        if ( !$subMenuToggle ) return;

        $subMenuToggle.addEventListener( 'click', e => {
            e.preventDefault();
            
            if ( $subMenuWrap.classList.contains('active') ) {
                disableSubMenu($subMenuWrap, $subMenuToggle);
            } else {
                enableSubMenu($subMenuWrap, $subMenuToggle);
            }
        } );

        $subMenuToggle.addEventListener( 'mouseover', () => enableSubMenu($subMenuWrap, $subMenuToggle) );

        $subMenuToggle.addEventListener( 'mouseout', () => disableSubMenu($subMenuWrap, $subMenuToggle) );

    } );

} )();
